import React from 'react'

import type { WCDRouteProps } from '.'
import { Page } from './components/Page'

export const verticalPageRoutes: WCDRouteProps = [
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(about-which|help)',
    component: () => <Page pagePath="vertical/AboutWhichPage" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(about-which)/sitemap',
    component: () => <Page pagePath="vertical/SitemapPage" />,
  },
  {
    live: false,
    exact: true,
    path: '/:verticalSlug(campaigns)',
    component: () => <Page pagePath="vertical/CampaignsPage" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(consumer-rights)',
    component: () => <Page pagePath="vertical/ConsumerRightsPage" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(my-appointments)',
    component: () => <Page pagePath="vertical/AppointmentsPage" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(news)/latest',
    component: () => <Page pagePath="vertical/NewsListingPage" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(news)',
    component: () => <Page pagePath="vertical/NewsPage" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(pension-scheme)',
    component: () => <Page pagePath="vertical/PensionsPage" />,
  },
  {
    live: false,
    exact: true,
    path: '/:verticalSlug(policy-and-insight)',
    component: () => <Page pagePath="vertical/PolicyAndInsightPage" />,
  },
  {
    live: true,
    exact: true,
    path: '/:verticalSlug(tech-and-appliances|technology|appliances|cars|travel|home-and-garden|baby-and-child|family|health|money)',
    component: () => <Page pagePath="vertical/ReviewsPage" />,
  },
]
